<template>
  <div>
    <v-text-field           
      :disabled="dis"
      v-model="selectedValue"
      @input="onSelect()"
      :outlined="outlined"
      :dense="dense"
      :rules="sinRules"
      :error-messages='errorMessage'
    />   
  </div>
</template>
<style scoped>
</style>
<script>
import domainHelper from "@/services/domainHelper";
import dataSvc from "@/services/dataService";
import axios from "axios";
export default {
  props: [
    "value",
    "dis",
    "copyfrom_sourcefield",
    "copyfrom_title",
    "onchangedcallbackparam",
    "css",
    "outlined",
    "dense",
    "isRequired"         
  ],
  data() {
    return {
      selectedValue: this.value,
      isValid: false,
      errorMessage:'',
      expression:"^(\\d{3}[\\s]+\\d{3}[\\s]+\\d{3})|(\\d{9})$", 
      sinRules:[
        v => !this.isRequired || (!!v || ''),
        v => (!this.isRequired && (!v || v.trim().length == 0)) || (new RegExp(this.expression)).test(v) || this.$t("errors.Invalid_SinNumber")
       
      ]
    };
  }, 
  watch: {
    value(n, o) {
      this.selectedValue = n;
    }
  },
  methods: {
    onSelect() {
      if (this.selectedValue == "") {
        this.$emit("input", this.selectedValue);
        return;
      }
      var isvalid = this.validateSIN();
      if (isvalid) {
        this.$emit("input", this.selectedValue);
      }
      try {
        this.$emit("onchangedisvalidcallback", isvalid);
      } catch (e) {
        // ignore
      }
    },
    validateSIN() {      
      if (!this.selectedValue) {        
        return true;
      } else {       
        if(!(new RegExp(this.expression)).test(this.selectedValue)){
           return false;
        }
        this.isValid = false;
        this.errorMessage = ""
        let postData = { SINNumber: this.selectedValue.replace(/\s/g, '') };  
        axios.post( domainHelper.getAPIHost() + "/public/IsValidCanadianSINNumber", postData )
          .then(res => {
            if (res.data.ReturnStatus.ReturnCode == 200) {
                this.$emit("input", this.selectedValue);
                this.isValid = true;
                return true;
            } else {
                this.errorMessage = this.$t("errors.Invalid_SinNumber");
                return false;  
            }
          });
      }
    },
    onCopyFrom() {
      try {
        this.selectedValue = this.copyfrom_sourcefield;
        this.$emit("input", this.selectedValue);
      } catch (e) {
        // ignore
      }
    }
  }  
};
</script>
